<template>
  <div class="box">
    <div class="table-container">
      <!-- 搜索区域 -->
      <div class="header-search-box flex align-items-center border-box">
        <div class="search-item">
          <span class="search-label">级别：</span>
          <a-select
            v-model="queryCriteria.type"
            style="width: 110px"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="省级">省级</a-select-option>
            <a-select-option value="市级">市级</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <span class="search-label">城市：</span>
          <a-select
            v-model="queryCriteria.city"
            style="width: 110px"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              :value="item.code"
              v-for="item in cityList"
              :key="item.code"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>

        <div class="search-item">
          <span class="search-label">类型：</span>
          <a-select
            v-model="queryCriteria.applyType"
            style="width: 110px"
          >
            <a-select-option value="0">全部</a-select-option>
            <a-select-option value="1">思政教育工作室</a-select-option>
            <a-select-option value="2">特色文化育人品牌</a-select-option>
          </a-select>
        </div>

        <div class="search-item">
          <span class="search-label">排序：</span>
          <a-select
            v-model="queryCriteria.sort"
            style="width: 110px"
          >
            <a-select-option value="desc">正序</a-select-option>
            <a-select-option value="asc">倒序</a-select-option>
          </a-select>
        </div>

        <a-button type="primary" class="search-btn" @click="goQuery">
          <a-icon type="search" />
          查询
        </a-button>
      </div>

      <!-- 表格区域 -->
      <div class="table-wrapper">
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="dataList"
          :loading="loading"
          @change="handleTableChange"
          :bordered="true"
          rowKey="id"
        >
          <!-- 序号列 -->
          <template slot="sequenceNumber" slot-scope="text, record, index">
            {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
          </template>
          <!-- 类型列 -->
          <template slot="applyTypeScope" slot-scope="text, record, index">
            {{ applyTypeMap[text] || "-" }}
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/index";

// 表格列配置
const BASE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "学校名称",
    dataIndex: "schoolName",
    align: "center",
    ellipsis: true,
  },
  {
    title: "级别",
    dataIndex: "type",
    align: "center",
    scopedSlots: { customRender: "scope" },
  },
  {
    title: "类型",
    dataIndex: "applyType",
    align: "center",
    scopedSlots: { customRender: "applyTypeScope" },
  },
  {
    title: "城市",
    dataIndex: "city",
    align: "center",
    scopedSlots: { customRender: "scope" },
  },
  {
    title: "数量",
    dataIndex: "num",
    align: "center",
    width: 90,
  },
];

export default {
  name: "DataTable",
  data() {
    return {
      columns: BASE_COLUMNS,
      dataList: [],
      loading: false,
      queryCriteria: {
        applyType: "0",
        type: "",
        city: "",
        sort: "desc",
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
        pageSizeOptions: ["10", "20", "50"],
      },
      selectedRowKeys: [],
      applyTypeMap: {
        1: "思政教育工作室",
        2: "特色文化育人品牌",
      },
      cityList: [
        {
          code: "140100",
          name: "太原市",
        },
        {
          code: "140200",
          name: "大同市",
        },
        {
          code: "140300",
          name: "阳泉市",
        },
        {
          code: "140400",
          name: "长治市",
        },
        {
          code: "140500",
          name: "晋城市",
        },
        {
          code: "140600",
          name: "朔州市",
        },
        {
          code: "140700",
          name: "晋中市",
        },
        {
          code: "140800",
          name: "运城市",
        },
        {
          code: "140900",
          name: "忻州市",
        },
        {
          code: "141000",
          name: "临汾市",
        },
        {
          code: "141100",
          name: "吕梁市",
        },
      ],
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取表格数据
    async getData() {
      this.loading = true;

      try {
        const params = {
          //   page: this.pagination.current,
          //   size: this.pagination.pageSize,
          applyType: this.queryCriteria.applyType,
          type: this.queryCriteria.type,
          city: this.queryCriteria.city,
          sort: this.queryCriteria.sort,
        };

        const res = await getAction("/lx/lxApply/countList", params);
        console.log("🚀 ~ getData ~ res:", res);

        if (res.code === 200) {
          this.dataList = res.result || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message.error(res.message || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    // 表格变化处理
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },

    // 选择变化
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 查询按钮点击
    goQuery() {
      this.pagination.current = 1;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 19px 26px;
  min-height: 450px;
}

.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;

  .search-item {
    display: flex;
    align-items: center;
    margin-right: 8px;

    .search-label {
      white-space: nowrap;
    }
  }

  .search-btn {
    width: 90px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #2155b5;
    border-radius: 6px;
    margin-left: 8px;

    // margin-right: 8px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}

.table-wrapper {
  background: #fff;
  border-radius: 4px;

  ::v-deep .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
  }
}

@media (max-width: 768px) {
  .header-search-box {
    flex-direction: column;
    align-items: flex-start;

    .search-item {
      width: 100%;
      margin-bottom: 8px;

      .ant-select {
        flex: 1;
      }
    }

    .search-btn {
      margin-left: 0;
      width: 100%;
    }
  }
}
</style>